module.exports = __webpack_public_path__ + "static/img/SN.6f27bd09.png";